var overflowTimeout;

function initRecentlyViewedSlider() {
    var recentlyviewedslider = new Swiper('.recently-viewed-slider', {
        spaceBetween: 30,
        mousewheel: {
            forceToAxis	: true
          },
          freeMode: {
            enabled: true,
            sticky: true,
          },
          scrollbar: {
            el: '.swiper-scrollbar',
          },
          breakpoints: {
            0: {
                slidesPerView: 2.2,
                spaceBetween: 15
            },
            749: {
                slidesPerView: 2.75,
                spaceBetween: 20
            },
            990: {
                slidesPerView: 4.2
            }
          },
          on: {
            setTransition: function (e) {
              document.body.classList.add('overscroll-x-none');
              window.clearTimeout(overflowTimeout);
              overflowTimeout = window.setTimeout(function(){
                document.body.classList.remove('overscroll-x-none');
              }, 300); 
            }      
           }
    });
}


function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
  const recentlyviewedouter = document.getElementsByClassName("recently-viewed-product-section");
  if(productData?.length < 1 || !productData) {
    recentlyviewedouter[0].classList.add('hidden');
    return;
  }
  const recentlyViewedHtml = [];
    productData.map((item, index) => {
    recentlyViewedHtml.unshift(`
    <div class="swiper-slide recently-viewed-grid-item scroll-trigger animate--slide-in">
      <a class="!no-underline" href="${item.productUrl}"> 
		<img class="aspect-square object-cover" src='${item.productImg}' loading="lazy" alt="${item.productImageAltText}"/>
      </a>
       <h5 class="mt-8"><a class="!no-underline" href="${item.productUrl}">${item.productTitle}</a></h5>
    </div>
   `);
  });
  const newProductData = `${recentlyViewedHtml.join("")}`;
  const fullContent = document.getElementsByClassName("recently-viewed-grid");
  fullContent[0].innerHTML = newProductData;
  initRecentlyViewedSlider();
}

getRecentlyViewedProducts();